import BuildContent from '@/components/build/BuildContent'

export default function BuildPage() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <BuildContent />
    </div>
  )
}